import { Button, Card, Checkbox, Col, Popconfirm, Row, Typography } from "antd";
import { EmailExtraFile } from "../hooks/useEmailAttachmentsApi";
import { FaTrash, FaFilePdf } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { useState } from "react";

const DOCUMENT_TYPE_FIELDS = [
  { key: "isActiveBudget", label: "Budget" },
  { key: "isActiveSaleOrder", label: "Sale order" },
  { key: "isActiveDeliveryForm", label: "Delivery form" },
  { key: "isActivePurchaseOrder", label: "Purchase order" },
  { key: "isActiveReturn", label: "Return" },
  { key: "isActiveReceipt", label: "Receipt" },
  { key: "isActivePaymentInAdvance", label: "Payment in advance" },
] as const;

function getFileName(fileUrl: string): string {
  return fileUrl?.split("/").pop() || fileUrl;
}

interface ExtraFileItemProps {
  item: EmailExtraFile;

  onUpdate: (item: EmailExtraFile, values: Partial<EmailExtraFile>) => Promise<void>;

  onDelete: (item: EmailExtraFile) => Promise<void>;
}

export default function ExtraFileItem({ item, onUpdate, onDelete }: ExtraFileItemProps) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleUpdate = async (values: Partial<EmailExtraFile>) => {
    setLoading(true);
    await onUpdate(item, values);
    setLoading(false);
  };

  const handleDelete = async () => {
    setLoading(true);
    await onDelete(item);
  };

  return (
    <Card size="small" className="extra-file-item" loading={loading}>
      <Row gutter={[16, 12]} align="middle">
        <Col flex="auto">
          <div className="extra-file-item__header">
            <FaFilePdf size={20} color="rgb(215, 46, 47)" className="extra-file-item__icon" />
            <Typography.Link
              href={item.fileUrl}
              target="_blank"
              strong
              editable={{
                onChange: value => handleUpdate({ label: value }),
                triggerType: ["icon"],
              }}
              className="extra-file-item__label"
            >
              {item.label || getFileName(item.fileUrl)}
            </Typography.Link>
          </div>
        </Col>
        <Col>
          <Popconfirm
            title={t("Are you sure you want to delete this attachment?")}
            overlayClassName="validate-popconfirm"
            onConfirm={handleDelete}
            okText={t("Yes")}
            cancelText={t("No")}
            placement="left"
          >
            <Button type="text" danger icon={<FaTrash />} size="small" />
          </Popconfirm>
        </Col>
      </Row>
      <div className="extra-file-item__checkboxes">
        {DOCUMENT_TYPE_FIELDS.map(({ key, label }) => (
          <Checkbox
            key={key}
            checked={item[key]}
            onChange={e => handleUpdate({ [key]: e.target.checked })}
          >
            {t(label)}
          </Checkbox>
        ))}
      </div>
    </Card>
  );
}
